var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["b-shadow-1", { visible: _vm.panelsVisible }],
      attrs: { id: "app-nav" }
    },
    [
      _vm._l(_vm.tabs, function(tab) {
        return _c(
          "button",
          {
            key: tab.name,
            class: [
              "tab-button",
              tab.name,
              { active: _vm.currentTab.name === tab.name }
            ],
            on: {
              click: function($event) {
                _vm.currentTab = tab
              }
            }
          },
          [_vm._v(_vm._s(tab.name))]
        )
      }),
      _vm._v(" "),
      _c("panel-home", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentTab.name === "Home",
            expression: "currentTab.name === 'Home'"
          }
        ]
      }),
      _vm._v(" "),
      _c("panel-filter", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentTab.name === "Filter",
            expression: "currentTab.name === 'Filter'"
          }
        ]
      }),
      _vm._v(" "),
      _c("div", {
        class: ["b-shadow-1", { visible: _vm.panelsVisible }],
        attrs: { id: "in-out" },
        on: {
          click: function($event) {
            _vm.panelsVisible = !_vm.panelsVisible
          }
        }
      }),
      _vm._v(" "),
      _c("panel-detail")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib?{}!./scripts/vue/AppNav.vue?vue&type=template&id=2b463df6&
// module id = 57
// module chunks = 0